import React, { useState, useMemo, useEffect, useRef } from "react";
import { getJWTCloudRun } from "@gc-npm/node.ssr-process.google-auth";
import { getStaticProps as getStaticPropsMethod } from "@gc-npm/pages.ssr-pages-handler";
import { getPropsFromReqPath } from "@gc-npm/utils.page.req-props-to-path";
import { getLandingPageHandler } from "@/utils/page/landing-pages";
import DisplayOnViewportIntersection from "@gc-npm/components.display-on-viewport-intersection";
import CustomizerComponent from "@gc-npm/components.customizer-component";
import MetaData from "@gc-npm/core.meta-data";
import Header from "@gc-npm/components.header-isr";
import Footer from "@gc-npm/components.footer";
import { wrapper } from "store";
import { END } from "redux-saga";
import Banner from "@/home_components/banner";
import FeaturedOffer from "@/home_components/featured-offer";
import DeviceSection from "@/home_components/devices-section";
import Teletipo from "@/home_components/teletipo";
// import getOptanonCookieInfo from "@gc-npm/utils.page.get-optanon-cookie-info";
import { LAYOUT, LOGGED_STATUS } from "@/constants/statusUser";
//const SuperBanner = dynamic(() => import("@gc-npm/components.superbanner"));
import SuperBanner from "@/home_components/superbanner";
import AdvantagesSection from "@/home_components/advantages-section";
import StreamingPlatformsSection from "@/home_components/streaming-platforms-section";
import Ecosystem from "@/home_components/ecosystem";
const {
  enrichPagePropsWithComponentNames,
} = require("@/utils/page/enrich-component-tagging");
const Home = (props) => {
  const {
    breadcrumbsProps,
    headerProps,
    seoInfo,
    teletipo,
    banner1,
    banner2,
    banner3,
    offerTitle,
    offer1,
    offer2,
    offer3,
    offer4,
    sliderContenidos,
    rendToRendDevices,
    freeDevices,
    advantages,
    ecosystem,
    stamps,
    superBanner,
    footerProps,
    scLogged,
    pageActivityNames,
  } = props;

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Header {...breadcrumbsProps} {...headerProps} scLogged={scLogged} />

      <main>
        <h1 className="visuallyhidden">Ofertas Fibra y Móvil + TV Movistar</h1>
        {scLogged && (
          <CustomizerComponent
            name={pageActivityNames.teletipo}
            Component={Teletipo}
            componentName="Teletipo"
            componentProps={teletipo}
            skeletonClassName="teletipo-skeleton"
          />
        )}

        {!scLogged &&
          teletipo &&
          teletipo.creativityName !== "CMS-EMPTY-CONTENT" && (
            <Teletipo {...teletipo} />
          )}

        {superBanner && (
          <CustomizerComponent
            name={pageActivityNames.superBanner}
            Component={SuperBanner}
            componentProps={superBanner}
            componentName="SuperBanner"
            skeletonClassName="skeleton-superbanner"
          />
        )}

        {banner1 && banner2 && banner3 && (
          <Banner
            bannerProps={{ ...[banner1, banner2, banner3], stamps }}
            scLogged={scLogged}
            activityNames={[
              pageActivityNames.banner1,
              pageActivityNames.banner2,
              pageActivityNames.banner3,
            ]}
          />
        )}
        <FeaturedOffer
          scLogged={scLogged}
          offerProps={[offer1, offer2, offer3, offer4]}
          offerActivities={[
            pageActivityNames.offer1,
            pageActivityNames.offer2,
            pageActivityNames.offer3,
            pageActivityNames.offer4,
          ]}
          title={offerTitle}
          titleActivity={pageActivityNames.offerTitle}
        />
        <div>
          <DisplayOnViewportIntersection options={{ rootMargin: "250px" }}>
            <DeviceSection
              rendToRendDevices={rendToRendDevices}
              rendToRendActivityName={pageActivityNames.rendToRendDevices}
              stamps={stamps}
              freeDevices={freeDevices}
              freeDevicesActivityName={pageActivityNames.freeDevices}
            />
          </DisplayOnViewportIntersection>
        </div>

        {scLogged && (
          <div style={{ minHeight: "450px" }}>
            <DisplayOnViewportIntersection options={{ rootMargin: "250px" }}>
              <CustomizerComponent
                name={pageActivityNames.sliderContenidos}
                Component={StreamingPlatformsSection}
                componentName="StreamingPlatformSection"
                componentProps={sliderContenidos}
              />
            </DisplayOnViewportIntersection>
          </div>
        )}

        {!scLogged && <StreamingPlatformsSection {...sliderContenidos} />}

        {scLogged && (
          <div style={{ minHeight: "500px" }}>
            <DisplayOnViewportIntersection options={{ rootMargin: "250px" }}>
              <CustomizerComponent
                name={pageActivityNames.ecosystem}
                Component={Ecosystem}
                componentProps={ecosystem}
                componentName="Ecosystem"
                skeletonClassName="skeleton-ecosystem"
              />
            </DisplayOnViewportIntersection>
          </div>
        )}

        {!scLogged && (
          <div style={{ minHeight: "500px" }}>
            <DisplayOnViewportIntersection options={{ rootMargin: "250px" }}>
              <Ecosystem {...ecosystem} />
            </DisplayOnViewportIntersection>
          </div>
        )}

        {scLogged && (
          <CustomizerComponent
            name={pageActivityNames.advantages}
            Component={AdvantagesSection}
            componentName="StreamingPlatformSection"
            componentProps={advantages}
          />
        )}

        {!scLogged && <AdvantagesSection {...advantages} />}
      </main>
      <Footer footerProps={footerProps} />
    </>
  );
};

export default Home;

const COMPONENT_NAMES_BY_ACTIVITY_KEY = {
  banner1: "BannerCardHero1",
  banner2: "BannerCardHero2",
  banner3: "BannerCardHero3",
  offer1: "OfferCard1",
  offer2: "OfferCard2",
  offer3: "OfferCard3",
  offer4: "OfferCard4",
  superBanner: "SuperBanner",
  sliderContenidos: "StreamingPlatformSection",
  ecosystem: "Ecosystem",
  advantages: "StreamingPlatformSection",
};

const MIDDLEWARE_PROPS_DELIMITER = "::___::";

const isHomeMiddlewarePath = (slugStringified) =>
  !slugStringified || slugStringified.includes(MIDDLEWARE_PROPS_DELIMITER);

export const getStaticPaths = getLandingPageHandler("/").getStaticPaths;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const { store, params } = data;
  const slugStringified = params.slug ? params.slug.join("/") : "";
  const isNotProd = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod";

  if (!isHomeMiddlewarePath(slugStringified)) {
    if (isNotProd) {
      console.log("[home:getStaticProps][ignored-slug]", {
        path: `/${slugStringified}`,
      });
    }

    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      notFound: true,
    };
  }

  const {
    slug,
    cookies,
    query,
    props: serverProps,
  } = getPropsFromReqPath(`/${slugStringified}`);
  const custoHeaders = await getJWTCloudRun("custo-standard");
  const context = store.getState().main.context;

  const pageName = serverProps.loggedStatus
    ? "CHAMELEON_HOME_LOGADO"
    : "CHAMELEON_HOME_NOLOGADO";
  const scLogged = Boolean(serverProps && serverProps.loggedStatus);
  const scX =
    serverProps && typeof serverProps.scX !== "undefined"
      ? serverProps.scX
      : "";
  const cookiePerso = Boolean(serverProps && serverProps.cookiePerso);
  const hasCookies = Boolean(serverProps && serverProps.cookies);

  if (isNotProd) {
    console.log("[home:getStaticProps][middleware-sc]", {
      path: `/${slugStringified}`,
      pageName,
      scX,
      layout: serverProps && serverProps.layout,
      scLogged,
      cookiePerso,
      hasCookies,
    });
  }

  const enrichedData = {
    ...data,
    sc: {
      logged: scLogged,
      x: scX,
    },
  };

  const { props: infoProps } = await getStaticPropsMethod(enrichedData, "", 4, {
    pathname: "/",
    orionAlias: "",
    seoLocation: "www.movistar.es",
    headerLocation: "/particulares",
    layout: "",
    custoPageName: pageName,
  });

  const pageInfo = infoProps.custoInfo;
  delete pageInfo.status;

  const creaIndex = {
    teletipo: 0,
    banner1: 1,
    banner2: 2,
    banner3: 3,
    offerTitle: 4,
    offer1: 5,
    offer2: 6,
    offer3: 7,
    offer4: 8,
    ecosystem: 9,
    rendToRendDevices: 10,
    freeDevices: 11,
    sliderContenidos: 12,
    advantages: 13,
    stamps: 14,
    superBanner: 15,
  };

  // funciona como un map, pero para objetos
  const objectMap = (obj, fn) =>
    Object.fromEntries(
      Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)])
    );

  const cleanImageSrcNodes = (node) => {
    if (!node || typeof node !== "object") return;

    if (Array.isArray(node)) {
      node.forEach(cleanImageSrcNodes);
      return;
    }

    Object.entries(node).forEach(([key, value]) => {
      if (
        /^Image-\d+$/.test(key) &&
        value &&
        typeof value === "object" &&
        Object.prototype.hasOwnProperty.call(value, "src")
      ) {
        value.src = "";
      }

      cleanImageSrcNodes(value);
    });
  };

  const pageKeys = Object.keys(pageInfo);

  // actividades de la página no logado
  const pageActivities = objectMap(
    creaIndex,
    (value) => pageInfo[pageKeys[value]] || null
  );

  const pageActivityNames = objectMap(
    creaIndex,
    (value) => pageKeys[value] || null
  );

  if (isNotProd) {
    console.log("[home:getStaticProps][static-page-props-sc]", {
      path: `/${slugStringified}`,
      pageName,
      scX,
      layout: serverProps && serverProps.layout,
      scLogged,
    });
  }

  if (
    infoProps.custoInfo["DISPOSITIVOS-STAMPS-MANAGER"] &&
    infoProps.custoInfo["DISPOSITIVOS-STAMPS-MANAGER"]["stamps"]
  ) {
    infoProps.custoInfo["CUSTO-STAMPS"] =
      infoProps.custoInfo["DISPOSITIVOS-STAMPS-MANAGER"]["stamps"];
    delete infoProps.custoInfo["DISPOSITIVOS-STAMPS-MANAGER"];
  }

  const enrichedPageActivities = enrichPagePropsWithComponentNames(
    pageActivities,
    COMPONENT_NAMES_BY_ACTIVITY_KEY
  );

  if (serverProps && serverProps.loggedStatus) {
    Object.values(enrichedPageActivities).forEach(cleanImageSrcNodes);
  }

  store.dispatch(END);
  await store.sagaTask.toPromise();

  const allProps2Return = {
    props: {
      seoInfo: { ...infoProps.seoInfo },
      headerProps: { ...infoProps.headerProps, location: "/" },
      breadcrumbsProps: { ...infoProps.breadcrumbsProps },
      footerProps: { ...infoProps.footerProps },
      pageActivityNames,
      ...enrichedPageActivities,
      scLogged,
    },
    revalidate: 600,
  };

  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }

  return allProps2Return;
});
